import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userForm: {}
  },
  mutations: {
    userData (state, data) { state.userData = data },
    userForm (state, form) { state.userForm = form },
    managementLevel (state, level) { state.userForm = level }
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js